/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getProviders } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

type GetProviderListOptions = {
  location: string;
  options?: UseQueryOptions;
  [key: string]: any;
};

export const useGetProviderList = (options: GetProviderListOptions) => {
  const { location, options: queryOptions, ...filters } = options;
  return useQuery({
    queryKey: userQueryKeys.providerListing(location, filters),
    queryFn: ({ signal }) => getProviders(location, { params: filters, signal }).then((res) => res.data),
    ...queryOptions,
  });
};
